<template>
    <b-form-row>
        <b-modal @hidden="close" size="xl" button-size="md" ref="finder" hide-footer :id="this.id" :title="prefix + title">
            <ConsultarOrcamento :autorizacaoSelecionada="autorizacaoSelecionada" :situacaoFixa="situacaoFixa" @rowSelect="rowSelect" :title="prefix + title" />
        </b-modal>

        <lg-form-input-finder v-if="!modalOnly" :value="computedValue" @input="updateValue"
            fieldDescription="numeroOrcamento" :label="label" invalidFeedback="Orçamento deve ser informado!"
            description="" @handleClean="rowSelect" :showClear="podeApagar" :disabled="disabled">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" pressed v-if="podeMudar" :disabled="disabled">
                    <b-icon icon="search" />
                </b-button>
            </template>
            <template #incluirFilhos v-if="mostrarIncluirFilhos">

                <b-form-group>
                    <label style="color: black; text-decoration: none; font: 12px Inter sans-serif"
                        for="incluirFilhos">Incluir
                        filhos</label>
                    <b-form-checkbox @change="selectFillhoClicked" class="ml-3" name="incluirFilhos"
                        v-model="incluirFilhos" :value="1" :unchecked-value="0" />
                </b-form-group>
            </template>

        </lg-form-input-finder>

    </b-form-row>
</template>
<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"
import ConsultarOrcamento from "@/modules/gestao-financeira/orcamento-previo/ConsultarOrcamento.vue"

export default {
    components: {
        LgFormInputFinder,
        ConsultarOrcamento
    },

    props: {
        autorizacaoSelecionada:{
            type:Object,
            default:null,
        },
        situacaoFixa: {
            type: Number,
            default: null,
        },

        modalOnly: {
            type: Boolean,
            default: false,
        },
        id: String,
        onDblClickOrcamentoList: Function,
        value: Object,
        departamento: Object,
        podeMudar: {
            type: Boolean,
            default: true,
        },
        podeApagar: {
            type: Boolean,
            default: true,
        },
        mostrarIncluirFilhos: {
            type: Boolean,
            default: false,
        },
        prefix: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "Orçamento*:"
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "Orçamento",
        },

    },


    mounted() {
        if (this.modalOnly)
            this.show();
    },

    watch: {
        value(newValue) {
            this.computedValue = newValue;
        },
    },
    computed: {
        computedValue: {
            get() {
                return this.localObject
            },
            set(newValue) {
                this.localObject = newValue
            },
        },
    },
    methods: {

        async show() {
            await this.$refs.finder.show()
            this.$bvModal.show(this.id)
        },
        updateValue(newValue) {
            this.computedValue = newValue
            this.$emit("rowSelect", newValue)
        },
        async close(){
            this.$emit("close")
            await this.$bvModal.hide(this.id)

        },
        async rowSelect(item) {
            this.computedValue = item
            this.$emit("rowSelect", this.localObject)
            await this.$bvModal.hide(this.id)
        },
    },
}
</script>
